/*LIBRARY*/
import { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SPINNER from "../common_spinner/SPINNER";
// import Modal from "../common_modal/Modal";
// import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import {
  gen_action,
  set_value_sini_data,
} from "../../App/actions/sini_data_actions";

/*PICTURE*/

/*FUNCTION*/
import generate_short_uuid from "../../App/validation/generate_short_uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const S_D_TEXT_AREA = ({
  auth,
  layer,
  project,
  loading_reducer,
  sini_data_reducer,
  set_value_sini_data,
  gen_action,
}) => {
  const { geo_layer_list, layer_id, layer_id_active } = layer;
  const { geo_project } = project;
  const { loading_item_array } = loading_reducer;
  const { max_rows_text_area, rows_text_area, request_id } = sini_data_reducer;

  const [selectedItems, setSelectedItems] = useState([]);
  const [listData, setListData] = useState([]);
  const [menuSelector, setMenuSelector] = useState([
    "kirim_csv",
    "data_resume",
  ]);
  const [features, setFeatures] = useState([]);
  const [prompt_text, setPromptText] = useState("");
  const [data_resume, setDataResume] = useState([]);
  const [csv_string_single_layer, setCsvStringSingleLayer] = useState("");

  const calculateTokenFromFeatures = useCallback(
    (currentFeatures) => {
      const currentLayer = geo_layer_list.find(
        (item) => item.geo_layer._id === layer_id,
      )?.geo_layer;

      if (!currentLayer) return;

      const allFields = (currentLayer.fields || []).filter((f) => !f.isStyle);

      if (allFields.length === 0 || currentFeatures.length === 0) return;

      // Ambil field yang TIDAK disembunyikan oleh SEMUA feature
      const visibleFields = allFields.filter((field) => {
        // Asal SATU feature menunjukkan field ini visible, maka field dianggap visible
        return currentFeatures.some((feature) => {
          const hidden = feature._hidden || {};
          return !hidden[field.key]; // false atau undefined = visible
        });
      });

      const csv_lines = [];

      // Header row hanya yang visible
      const header_row = visibleFields.map((f) => `"${f.name}"`).join(";");
      csv_lines.push(header_row);

      currentFeatures.forEach((feature) => {
        const hidden = feature._hidden || {};
        const dataRow = visibleFields
          .map((field) => {
            // Skip field jika disembunyikan
            if (hidden[field.key]) return `""`;

            const val = feature.properties?.[field.key];
            return `"${
              val !== undefined && val !== null
                ? String(val).replace(/"/g, '""')
                : ""
            }"`;
          })
          .join(";");
        csv_lines.push(dataRow);
      });

      const combined_csv_string = csv_lines.join("\n");

      const estimated_token_count = Math.ceil(combined_csv_string.length / 4);
      const limit_value_resume = 100;

      const filterData = [
        "simple_referring",
        "calculate_dimension",
        "math_operators",
        "2d_referring",
        "conditional_statement",
        "nilai_pembanding",
        "jarak_apraisal",
        "summary_of_nested_table",
        "table_formula",
        "auto_generate_user_name",
        "capex_value",
      ];

      const filteredFields = allFields.filter((field) =>
        filterData.includes(field.type),
      );

      if (filteredFields.length > 0) {
        const calculateDimensionFields = filteredFields.map((field) => {
          const key = field.key;
          const count_map = {};

          // ── Hitung frekuensi nilai ───────────────────────
          currentFeatures.forEach((feature) => {
            const value = feature.properties[key];
            if (value != null) {
              count_map[value] = (count_map[value] || 0) + 1;
            }
          });

          const value_resume = Object.entries(count_map)
            .slice(0, limit_value_resume)
            .map(([value, count]) => ({ value, count }));

          // ── Hitung min / max / sum numerik ───────────────
          let min = Infinity;
          let max = -Infinity;
          let sum = 0;
          let hasNumeric = false;

          currentFeatures.forEach((feature) => {
            const num = Number(feature.properties[key]);
            if (!isNaN(num)) {
              hasNumeric = true;
              min = Math.min(min, num);
              max = Math.max(max, num);
              sum += num;
            }
          });

          return {
            key,
            value_resume,
            min: hasNumeric ? min : null,
            max: hasNumeric ? max : null,
            sum: hasNumeric ? sum : null,
          };
        });
        const new_data_resume = { fileds: calculateDimensionFields };
        setDataResume(new_data_resume);
      }

      set_value_sini_data({
        key: "estimated_token_used",
        value: estimated_token_count,
      });

      setCsvStringSingleLayer(combined_csv_string);
    },
    [geo_layer_list, layer_id, set_value_sini_data],
  );

  useEffect(() => {
    let allFeatures = [];

    // Ambil semua features dari layer yang aktif
    layer_id_active.forEach((id) => {
      const currentLayer = geo_layer_list.find((l) => l?.geo_layer?._id === id);
      if (!currentLayer?.geo_layer) return;

      const layerFeatures = currentLayer.geo_layer.geojson?.features || [];
      allFeatures.push(...layerFeatures);
    });

    // Ambil fields untuk ditampilkan
    const geo_layer = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id,
    )?.geo_layer;

    const fields = geo_layer?.fields?.filter((item) => !item.isStyle) || [];

    // Set ke state dulu, baru hitung token
    setListData(fields);
    setFeatures(allFeatures);
    calculateTokenFromFeatures(allFeatures);
  }, [layer_id_active, geo_layer_list, layer_id, calculateTokenFromFeatures]);

  const on_change_props = (event) => {
    const textarea_line_height = 24;
    const previous_rows = event.target.rows;
    event.target.rows = 1;

    let current_rows = Math.floor(
      event.target.scrollHeight / textarea_line_height,
    );

    // FIX: Force a minimum of 2 rows
    if (current_rows < 2) {
      current_rows = 2;
    }

    if (current_rows === previous_rows) {
      event.target.rows = current_rows;
    }

    if (current_rows >= max_rows_text_area) {
      event.target.rows = max_rows_text_area;
      event.target.scrollTop = event.target.scrollHeight;
    } else {
      // Safely apply current rows if below max
      event.target.rows = current_rows;
    }

    const value = event.target.value;
    setPromptText(value);

    if (value.trim() === "") {
      set_value_sini_data({
        key: "rows_text_area",
        value: 2,
      });
    } else {
      set_value_sini_data({
        key: "rows_text_area",
        value:
          current_rows < max_rows_text_area ? current_rows : max_rows_text_area,
      });
    }
  };

  const on_init_sini_data = () => {
    const current_request_id = request_id ? request_id : generate_short_uuid();

    set_value_sini_data({
      key: "request_id",
      value: current_request_id,
    });

    const layer_name_list = layer_id_active.map((id) => {
      const layer_name = geo_layer_list.find(
        (layerItem) => layerItem?.geo_layer?._id === id,
      )?.geo_layer?.name;
      return layer_name;
    });
    const layer_type_list = layer_id_active.map((id) => {
      const layer_type = geo_layer_list.find(
        (layerItem) => layerItem?.geo_layer?._id === id,
      )?.geo_layer?.type;
      return layer_type;
    });

    const layer_data_csv = [csv_string_single_layer || ""];

    if (prompt_text !== "") {
      const body = {
        request_id: current_request_id,
        project_id: geo_project._id,
        prompt_text,
        layer_name_list,
        layer_id_list: layer_id_active,
        layer_type_list,
        layer_data_csv,
        settings: menuSelector,
        data_resume_fe: data_resume,
      };
      gen_action(body);
    }

    setPromptText("");
    set_value_sini_data({
      key: "rows_text_area",
      value: 2,
    });
  };

  const toggleItem = (item) => {
    const isSelected = selectedItems.includes(item);

    const updatedItems = isSelected
      ? selectedItems.filter((val) => val !== item)
      : [...selectedItems, item];

    const updatedFeatures = features.map((feature) => {
      const newFeature = { ...feature, properties: { ...feature.properties } };

      if (!newFeature._hidden) newFeature._hidden = {}; // simpan status hidden per key

      if (item?.key in newFeature._hidden) {
        newFeature._hidden[item.key] = !newFeature._hidden[item.key];
      } else {
        newFeature._hidden[item.key] = true;
      }

      return newFeature;
    });

    setSelectedItems(updatedItems);
    setFeatures(updatedFeatures);
    calculateTokenFromFeatures(updatedFeatures);
  };

  const toggleAllItems = () => {
    const isAllSelected = selectedItems.length === listData.length;

    const updatedItems = isAllSelected ? [] : [...listData];

    const updatedFeatures = features.map((feature) => {
      const newFeature = { ...feature, properties: { ...feature.properties } };
      if (!newFeature._hidden) newFeature._hidden = {};

      listData.forEach((item) => {
        newFeature._hidden[item.key] = !isAllSelected;
      });

      return newFeature;
    });

    setSelectedItems(updatedItems);
    setFeatures(updatedFeatures);
    calculateTokenFromFeatures(updatedFeatures);
  };

  const setmenuSelector = (dt) => {
    setMenuSelector((prev) => {
      const sudahAda = prev.includes(dt);

      return sudahAda
        ? prev.filter((item) => item !== dt) // take‑out
        : [...prev, dt]; // push
    });
  };

  //local storage
  const language = localStorage?.language || auth.language || "ina";

  //content
  const content_menu = menuSelector.includes("edit_fields") && (
    <div
      id="custom_selection_list"
      style={{
        position: "absolute",
        left: 0,
        width: 240,
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,.15)",
        maxHeight: "40vh",
        overflowY: "auto",
        zIndex: 9999,
        top: "auto",
        bottom: "calc(100% + 8px)",
      }}
    >
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <button
                onClick={toggleAllItems}
                className={
                  selectedItems.length === listData.length
                    ? "checklist_not"
                    : "checklist_active"
                }
              />
            </td>
            <td onClick={toggleAllItems} className="side">
              {dict?.["All"]?.[language] || "All"}
            </td>
          </tr>

          {listData?.map((item, idx) => {
            const isActive = selectedItems.includes(item);
            return (
              <tr key={idx}>
                <td>
                  <button
                    onClick={() => toggleItem(item)}
                    className={isActive ? "checklist_not" : "checklist_active"}
                  />
                </td>
                <td onClick={() => toggleItem(item)} className="side">
                  {item.name}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  return (
    <main>
      <textarea
        placeholder={
          dict?.["Create graphs, legends, data insights"]?.[language]
        }
        // FIX: Ensure rows defaults to at least 2
        rows={Math.max(2, rows_text_area || 2)}
        className="margin_bottom"
        value={prompt_text}
        name="prompt_text"
        onChange={on_change_props}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            on_init_sini_data();
          }
        }}
        // FIX: Inline styling for precise line-height matching, min-height, and padding
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          lineHeight: "24px", // Matches the JS variable `textarea_line_height`
          minHeight: "48px", // Forces a physical minimum height of 2 rows
          padding: "8px 12px", // Gives breathing room so text isn't pressed against edges
          boxSizing: "border-box", // Stops padding from expanding the width beyond 100%
          width: "100%",
          resize: "vertical", // Best practice to allow vertical resize only
        }}
      />

      {content_menu}

      {loading_item_array.includes("gen_action") ? (
        <button className="button background_black margin_bottom">
          {dict?.["Sending"]?.[language]}{" "}
          <SPINNER
            unik="ai_spinner"
            width={10}
            border={0.25}
            color1="white"
            color2="#28a3f5"
          />
        </button>
      ) : (
        <button
          className="button background_black margin_bottom"
          onClick={on_init_sini_data}
        >
          {dict?.["Send"]?.[language]}
        </button>
      )}
      <br />
      <div
        className="margin_top text_medium"
        onClick={() => setmenuSelector("pertahankan_konteks")}
        title={
          dict?.[
            "Maintain context in chats so that AI remembers previous conversations."
          ]?.[language]
        }
      >
        <span
          className={
            menuSelector.includes("pertahankan_konteks")
              ? "checklist_active"
              : "checklist_not"
          }
          style={{ marginRight: "10px" }}
        />

        {dict?.["Maintain Context"]?.[language]}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, { set_value_sini_data, gen_action })(
  S_D_TEXT_AREA,
);
